(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-date-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var globalState = window.__DeliveryDatePickerLineItemProperties || {
      activePayload: null,
      patched: false
    };

    window.__DeliveryDatePickerLineItemProperties = globalState;

    function initAll() {
      installCartAddRequestPatch();

      document.querySelectorAll('[data-ddp]').forEach(function (root) {
        if (root.dataset.ddpReady === 'true') return;

        root.dataset.ddpReady = 'true';

        try {
          new DeliveryDatePicker(root);
        } catch (error) {
          console.error('[delivery-date-picker]', error);
        }
      });
    }

    function isCartAddUrl(resource) {
      var url = '';

      if (typeof resource === 'string') {
        url = resource;
      } else if (resource && typeof resource.url === 'string') {
        url = resource.url;
      }

      if (!url) return false;

      try {
        url = new URL(url, window.location.origin).pathname;
      } catch (error) {
        /* keep original string */
      }

      return /\/cart\/add(?:\.js)?$/.test(url);
    }

    function getActivePayload() {
      var payload = globalState.activePayload;

      if (!payload || !payload.human) return null;

      if (payload.expiresAt && Date.now() > payload.expiresAt) {
        globalState.activePayload = null;
        return null;
      }

      return payload;
    }

    function setFormDataValue(formData, name, value) {
      if (!formData || !name) return;

      if (typeof formData.set === 'function') {
        formData.set(name, value || '');
        return;
      }

      if (typeof formData.append === 'function') {
        formData.append(name, value || '');
      }
    }

    function mergePropertiesObject(target, payload) {
      if (!target || !payload || !payload.human) return;

      if (!target.properties || typeof target.properties !== 'object' || Array.isArray(target.properties)) {
        target.properties = {};
      }

      target.properties['Delivery / Collection Date'] = payload.human;

      if (payload.iso) {
        target.properties['_Delivery / Collection Date ISO'] = payload.iso;
      }
    }

    function activePayloadMatchesItem(item, payload) {
      if (!item || !payload || !payload.variantId) return false;

      return String(item.id || item.variant_id || '') === String(payload.variantId);
    }

    function injectPayloadIntoRequestBody(body, payload) {
      if (!payload || !payload.human || !body) return body;

      if (window.FormData && body instanceof FormData) {
        setFormDataValue(body, 'properties[Delivery / Collection Date]', payload.human);
        setFormDataValue(body, 'properties[_Delivery / Collection Date ISO]', payload.iso || '');
        return body;
      }

      if (window.URLSearchParams && body instanceof URLSearchParams) {
        body.set('properties[Delivery / Collection Date]', payload.human);
        body.set('properties[_Delivery / Collection Date ISO]', payload.iso || '');
        return body;
      }

      if (typeof body === 'string') {
        var trimmed = body.trim();

        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          try {
            var json = JSON.parse(body);

            if (json && Array.isArray(json.items)) {
              var matched = false;

              json.items.forEach(function (item) {
                if (activePayloadMatchesItem(item, payload)) {
                  mergePropertiesObject(item, payload);
                  matched = true;
                }
              });

              if (!matched && json.items[0]) {
                mergePropertiesObject(json.items[0], payload);
              }
            } else if (json && typeof json === 'object') {
              mergePropertiesObject(json, payload);
            }

            return JSON.stringify(json);
          } catch (error) {
            /* fall through to URL encoded handling */
          }
        }

        try {
          var params = new URLSearchParams(body);

          if (params.has('id') || params.has('quantity') || params.has('form_type')) {
            params.set('properties[Delivery / Collection Date]', payload.human);
            params.set('properties[_Delivery / Collection Date ISO]', payload.iso || '');
            return params.toString();
          }
        } catch (error) {
          /* leave original body untouched */
        }

        return body;
      }

      return body;
    }

    function installCartAddRequestPatch() {
      if (globalState.patched) return;

      globalState.patched = true;

      if (typeof window.fetch === 'function') {
        var originalFetch = window.fetch;

        window.fetch = function (resource, init) {
          if (isCartAddUrl(resource)) {
            var payload = getActivePayload();

            if (payload) {
              init = init ? Object.assign({}, init) : {};

              if (init.body) {
                init.body = injectPayloadIntoRequestBody(init.body, payload);
              }
            }
          }

          return originalFetch.call(this, resource, init);
        };
      }

      if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
        var originalOpen = window.XMLHttpRequest.prototype.open;
        var originalSend = window.XMLHttpRequest.prototype.send;

        window.XMLHttpRequest.prototype.open = function (method, url) {
          this.__ddpCartAddUrl = isCartAddUrl(url);
          return originalOpen.apply(this, arguments);
        };

        window.XMLHttpRequest.prototype.send = function (body) {
          if (this.__ddpCartAddUrl) {
            body = injectPayloadIntoRequestBody(body, getActivePayload());
          }

          return originalSend.call(this, body);
        };
      }
    }

    function DeliveryDatePicker(root) {
      var id = root.getAttribute('data-ddp-id');
      var cfgScript = root.querySelector('script[data-ddp-config="' + id + '"]');

      if (!cfgScript) return;

      var cfg = JSON.parse(cfgScript.textContent);

      cfg.leadDays = parseInt(cfg.leadDays, 10) || 0;
      cfg.horizonDays = parseInt(cfg.horizonDays, 10) || 90;

      cfg.enableSameDay =
        cfg.enableSameDay === true ||
        cfg.enableSameDay === 'true' ||
        cfg.enableSameDay === 1 ||
        cfg.enableSameDay === '1' ||
        cfg.enableSameDay === 'yes';

      cfg.sameDayExcludedForProduct =
        cfg.sameDayExcludedForProduct === true ||
        cfg.sameDayExcludedForProduct === 'true' ||
        cfg.sameDayExcludedForProduct === 1 ||
        cfg.sameDayExcludedForProduct === '1' ||
        cfg.sameDayExcludedForProduct === 'yes';

      var grid = root.querySelector('[data-ddp-grid]');
      var monthLabel = root.querySelector('[data-ddp-month]');
      var prevBtn = root.querySelector('[data-ddp-prev]');
      var nextBtn = root.querySelector('[data-ddp-next]');
      var cutoffEl = root.querySelector('[data-ddp-cutoff]');
      var noticeEl = root.querySelector('[data-ddp-notice]');
      var selectedEl = root.querySelector('[data-ddp-selected]');
      var warnEl = root.querySelector('[data-ddp-warning]');
      var fieldBtn = root.querySelector('[data-ddp-field]');
      var fieldText = root.querySelector('[data-ddp-field-text]');
      var calendarEl = root.querySelector('[data-ddp-calendar]');
      var calendarPanel = root.querySelector('[data-ddp-calendar-panel]');
      var nativeDateInput = root.querySelector('[data-ddp-native-input]');
      var isoDateInput = root.querySelector('[data-ddp-iso-input]');

      if (!grid || !monthLabel || !prevBtn || !nextBtn || !cutoffEl || !noticeEl || !selectedEl || !warnEl || !fieldBtn || !fieldText || !calendarEl || !calendarPanel || !nativeDateInput || !isoDateInput) {
        return;
      }

      var placeholderText = cfg.placeholder || 'Select delivery date';
      var supportsPopover =
        typeof calendarEl.showPopover === 'function' &&
        typeof calendarEl.hidePopover === 'function';

      var ignoreDocumentClick = false;

      fieldBtn.setAttribute('data-empty', 'true');
      fieldText.textContent = placeholderText;

      function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      }

      function iso(d) {
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
      }

      function addDays(d, n) {
        var x = new Date(d);
        x.setDate(x.getDate() + n);
        return x;
      }

      function toDate(s) {
        if (!s) return null;

        var m = String(s).split('-');

        if (m.length !== 3) return null;

        return new Date(parseInt(m[0], 10), parseInt(m[1], 10) - 1, parseInt(m[2], 10));
      }

      function parseDates(raw) {
        var set = {};

        String(raw || '').split(/[\n,]+/).forEach(function (s) {
          s = s.trim();

          if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            set[s] = true;
          }
        });

        return set;
      }

      function parseDays(raw, fallback) {
        if (!raw) return fallback;

        var map = {
          sun: 0,
          sunday: 0,
          mon: 1,
          monday: 1,
          tue: 2,
          tues: 2,
          tuesday: 2,
          wed: 3,
          weds: 3,
          wednesday: 3,
          thu: 4,
          thur: 4,
          thurs: 4,
          thursday: 4,
          fri: 5,
          friday: 5,
          sat: 6,
          saturday: 6
        };

        var arr = [false, false, false, false, false, false, false];
        var any = false;

        String(raw || '').split(/[\s,]+/).forEach(function (t) {
          t = t.trim().toLowerCase();

          if (!t) return;

          if (/^\d$/.test(t)) {
            var n = parseInt(t, 10);

            if (n >= 0 && n <= 6) {
              arr[n] = true;
              any = true;
            }

            return;
          }

          if (map.hasOwnProperty(t)) {
            arr[map[t]] = true;
            any = true;
          }
        });

        return any ? arr : fallback;
      }

      var deliverWeekday = parseDays(
        cfg.configDaysRaw,
        cfg.deliverWeekday || [true, false, true, true, true, true, true]
      );

      var cp = String(cfg.cutoff || '12:00').split(':');
      var cutMin = ((parseInt(cp[0], 10) || 0) * 60) + (parseInt(cp[1], 10) || 0);
      var rangeStart = toDate(cfg.rangeStart);
      var rangeEnd = toDate(cfg.rangeEnd);
      var closed = parseDates(cfg.closedRaw);
      var open = parseDates(cfg.openRaw);

      var selected = null;
      var sameDayAllowed;
      var normalEarliest;
      var normalMax;
      var earliestBound;
      var maxBound;
      var todayG;
      var view;

      function sameDayFeatureOn() {
        return cfg.enableSameDay && !cfg.sameDayExcludedForProduct && cfg.leadDays <= 0;
      }

      function shopParts() {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: cfg.timezone || 'Europe/London',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).formatToParts(new Date());

        var o = {};

        parts.forEach(function (p) {
          if (p.type !== 'literal') {
            o[p.type] = parseInt(p.value, 10);
          }
        });

        if (o.hour === 24) {
          o.hour = 0;
        }

        return o;
      }

      function todayDate() {
        var p = shopParts();

        return new Date(p.year, p.month - 1, p.day);
      }

      function isDeliverableNormal(d) {
        var key = iso(d);

        if (!deliverWeekday[d.getDay()]) return false;
        if (closed[key]) return false;
        if (rangeStart && d < rangeStart) return false;

        return true;
      }

      function compute() {
        var now = shopParts();
        var today = todayDate();
        var nowMin = (now.hour * 60) + now.minute;

        sameDayAllowed =
          sameDayFeatureOn() &&
          nowMin < cutMin &&
          isDeliverableNormal(today);

        var startOffset = cfg.leadDays > 0 ? cfg.leadDays : (sameDayAllowed ? 0 : 1);
        var ne = addDays(today, startOffset);

        if (rangeStart && ne < rangeStart) {
          ne = new Date(rangeStart);
        }

        var guard = 0;

        while (!isDeliverableNormal(ne) && guard <= 730) {
          ne = addDays(ne, 1);
          guard++;
        }

        normalEarliest = ne;
        normalMax = rangeEnd ? new Date(rangeEnd) : addDays(today, cfg.horizonDays);

        var minB = new Date(normalEarliest);
        var maxB = new Date(normalMax);

        Object.keys(open).forEach(function (k) {
          var od = toDate(k);

          if (!od || od < today) return;
          if (od < minB) minB = od;
          if (od > maxB) maxB = od;
        });

        earliestBound = minB;
        maxBound = maxB;
        todayG = today;

        return {
          now: now,
          today: today
        };
      }

      function selectable(d) {
        if (d < todayG) return false;

        var key = iso(d);

        if (open[key]) return d <= maxBound;
        if (d < normalEarliest) return false;
        if (d > normalMax) return false;
        if (!isDeliverableNormal(d)) return false;

        return true;
      }

      function firstSelectableDate() {
        var d = new Date(earliestBound);
        var guard = 0;

        while (d <= maxBound && guard <= 730) {
          if (selectable(d)) {
            return d;
          }

          d = addDays(d, 1);
          guard++;
        }

        return null;
      }

      function formatHumanDate(d) {
        if (!d) return '';

        return d.toLocaleDateString('en-GB', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        });
      }

      function renderCutoffMsg(state) {
        if (!sameDayFeatureOn()) {
          cutoffEl.hidden = true;
          cutoffEl.textContent = '';
          cutoffEl.removeAttribute('data-open');
          return;
        }

        if (sameDayAllowed) {
          cutoffEl.hidden = false;
          cutoffEl.setAttribute('data-open', 'true');
          cutoffEl.textContent = String(cfg.labels.sameDayAvailable || '').replace('[time]', cfg.cutoff);
          return;
        }

        var passedMessage = cfg.labels.sameDayPassed || '';
        var earliestDate = firstSelectableDate();
        var earliestText = formatHumanDate(earliestDate);

        if (passedMessage.indexOf('[date]') !== -1) {
          passedMessage = passedMessage.replace('[date]', earliestText);
        }

        if (passedMessage.indexOf('[time]') !== -1) {
          passedMessage = passedMessage.replace('[time]', cfg.cutoff);
        }

        cutoffEl.hidden = false;
        cutoffEl.removeAttribute('data-open');
        cutoffEl.textContent = passedMessage;
      }

      function renderNotice() {
        var msg = cfg.noticeMessage;

        if (!msg) {
          noticeEl.hidden = true;
          noticeEl.textContent = '';
          return;
        }

        if (msg.indexOf('[date]') !== -1) {
          msg = msg.replace('[date]', formatHumanDate(firstSelectableDate()));
        }

        if (msg.indexOf('[time]') !== -1) {
          msg = msg.replace('[time]', cfg.cutoff);
        }

        noticeEl.hidden = false;
        noticeEl.textContent = msg;
      }

      function showExpiredWarning() {
        if (!sameDayFeatureOn()) return;

        warnEl.hidden = false;
        warnEl.textContent = cfg.labels.expired;
      }

      function render() {
        monthLabel.textContent = view.toLocaleDateString('en-GB', {
          month: 'long',
          year: 'numeric'
        });

        grid.innerHTML = '';

        var firstDow = (new Date(view.getFullYear(), view.getMonth(), 1).getDay() + 6) % 7;

        for (var s = 0; s < firstDow; s++) {
          var sp = document.createElement('span');
          sp.className = 'ddp__day';
          sp.setAttribute('data-spacer', 'true');
          grid.appendChild(sp);
        }

        var daysInMonth = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();

        for (var day = 1; day <= daysInMonth; day++) {
          var d = new Date(view.getFullYear(), view.getMonth(), day);
          var btn = document.createElement('button');

          btn.type = 'button';
          btn.className = 'ddp__day';
          btn.textContent = day;

          var ok = selectable(d);

          btn.disabled = !ok;

          if (iso(d) === iso(todayG)) {
            btn.setAttribute('data-today', 'true');
          }

          if (selected && iso(d) === iso(selected)) {
            btn.setAttribute('aria-pressed', 'true');
          }

          btn.setAttribute('aria-label', formatHumanDate(d));

          if (ok) {
            (function (date) {
              btn.addEventListener('click', function () {
                choose(date);
              });
            })(d);
          }

          grid.appendChild(btn);
        }

        prevBtn.disabled = view <= new Date(earliestBound.getFullYear(), earliestBound.getMonth(), 1);
        nextBtn.disabled = view >= new Date(maxBound.getFullYear(), maxBound.getMonth(), 1);
      }

      function isCalendarOpen() {
        if (supportsPopover) {
          try {
            return calendarEl.matches(':popover-open');
          } catch (error) {
            return calendarEl.getAttribute('data-ddp-fallback-open') === 'true';
          }
        }

        return calendarEl.getAttribute('data-ddp-fallback-open') === 'true';
      }

      function positionCalendar() {
        if (!supportsPopover) {
          return true;
        }

        var rect = fieldBtn.getBoundingClientRect();

        if (!rect || (rect.width === 0 && rect.height === 0)) {
          return false;
        }

        var viewportPadding = 12;
        var gap = 8;
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        var width = Math.min(rect.width, viewportWidth - (viewportPadding * 2));
        var left = rect.left;

        if (left + width > viewportWidth - viewportPadding) {
          left = viewportWidth - viewportPadding - width;
        }

        if (left < viewportPadding) {
          left = viewportPadding;
        }

        var top = rect.bottom + gap;
        var maxHeightBelow = viewportHeight - rect.bottom - gap - viewportPadding;
        var maxHeightAbove = rect.top - gap - viewportPadding;
        var maxHeight = Math.max(260, maxHeightBelow);

        calendarEl.style.setProperty('position', 'fixed', 'important');
        calendarEl.style.setProperty('inset', 'auto', 'important');
        calendarEl.style.setProperty('left', left + 'px', 'important');
        calendarEl.style.setProperty('top', top + 'px', 'important');
        calendarEl.style.setProperty('width', width + 'px', 'important');
        calendarEl.style.setProperty('max-width', 'none', 'important');
        calendarEl.style.setProperty('max-height', maxHeight + 'px', 'important');
        calendarEl.style.setProperty('margin', '0', 'important');
        calendarEl.style.setProperty('transform', 'none', 'important');
        calendarEl.style.setProperty('z-index', '2147483647', 'important');

        calendarPanel.style.setProperty('max-height', maxHeight + 'px', 'important');
        calendarPanel.style.setProperty('overflow-y', 'auto', 'important');

        var calendarHeight = calendarEl.offsetHeight;

        if (calendarHeight > maxHeightBelow && maxHeightAbove > maxHeightBelow) {
          var aboveTop = rect.top - gap - Math.min(calendarHeight, maxHeightAbove);
          var correctedTop = Math.max(viewportPadding, aboveTop);
          var correctedMaxHeight = Math.max(260, maxHeightAbove);

          calendarEl.style.setProperty('top', correctedTop + 'px', 'important');
          calendarEl.style.setProperty('max-height', correctedMaxHeight + 'px', 'important');
          calendarPanel.style.setProperty('max-height', correctedMaxHeight + 'px', 'important');
        }

        return true;
      }

      function openCalendar() {
        var state = compute();

        if (selected && !selectable(selected)) {
          clearSelection();
          showExpiredWarning();
        }

        if (selected) {
          view = new Date(selected.getFullYear(), selected.getMonth(), 1);
        } else if (!view) {
          view = new Date(earliestBound.getFullYear(), earliestBound.getMonth(), 1);
        }

        renderCutoffMsg(state);
        renderNotice();
        render();

        root.setAttribute('data-ddp-open', 'true');
        fieldBtn.setAttribute('aria-expanded', 'true');

        if (supportsPopover) {
          positionCalendar();

          if (!isCalendarOpen()) {
            try {
              calendarEl.showPopover();
            } catch (error) {
              /* already showing */
            }
          }

          if (!positionCalendar()) {
            window.requestAnimationFrame(positionCalendar);
          }

          window.requestAnimationFrame(function () {
            positionCalendar();
          });

          window.setTimeout(function () {
            positionCalendar();
          }, 50);
        } else {
          calendarEl.setAttribute('data-ddp-fallback-open', 'true');
        }
      }

      function closeCalendar() {
        root.removeAttribute('data-ddp-open');
        fieldBtn.setAttribute('aria-expanded', 'false');

        if (supportsPopover && isCalendarOpen()) {
          try {
            calendarEl.hidePopover();
          } catch (error) {
            /* already hidden */
          }
        }

        calendarEl.removeAttribute('data-ddp-fallback-open');
      }

      function toggleCalendar(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        ignoreDocumentClick = true;

        window.setTimeout(function () {
          ignoreDocumentClick = false;
        }, 0);

        if (isCalendarOpen()) {
          closeCalendar();
        } else {
          openCalendar();
        }
      }

      function clearSelection() {
        selected = null;
        fieldText.textContent = placeholderText;
        fieldBtn.setAttribute('data-empty', 'true');
        selectedEl.hidden = true;
        writeToForm('', '');
        setSubmitState(false);
      }

      function renderSelectedDate(human) {
        fieldText.textContent = human;
        fieldBtn.removeAttribute('data-empty');
        selectedEl.textContent = '';
        selectedEl.hidden = true;
      }

      function choose(d) {
        selected = d;

        var human = formatHumanDate(d);

        renderSelectedDate(human);
        warnEl.hidden = true;
        writeToForm(human, iso(d));
        setSubmitState(true);
        refresh();
        closeCalendar();
      }

      function refresh() {
        var state = compute();

        if (selected && !selectable(selected)) {
          clearSelection();
          showExpiredWarning();
        }

        if (!view) {
          view = new Date(earliestBound.getFullYear(), earliestBound.getMonth(), 1);
        }

        renderCutoffMsg(state);
        renderNotice();
        render();

        if (isCalendarOpen()) {
          positionCalendar();
        }

        if (!selectable(earliestBound) && !selectable(normalEarliest)) {
          warnEl.hidden = false;
          warnEl.textContent = cfg.labels.none;
        }

        setSubmitState(!cfg.requireDate || (selected && selectable(selected)));
      }

      prevBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
        render();
        positionCalendar();
      });

      nextBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
        render();
        positionCalendar();
      });

      fieldBtn.addEventListener('click', toggleCalendar);

      fieldBtn.addEventListener('keydown', function (event) {
        if (
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.key === 'Spacebar' ||
          event.key === 'ArrowDown'
        ) {
          event.preventDefault();
          toggleCalendar(event);
        }

        if (event.key === 'Escape') {
          closeCalendar();
        }
      });

      calendarEl.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeCalendar();
          fieldBtn.focus();
        }
      });

      calendarEl.addEventListener('click', function (event) {
        event.stopPropagation();
      });

      document.addEventListener('click', function (event) {
        if (ignoreDocumentClick) return;

        if (!root.contains(event.target) && !calendarEl.contains(event.target)) {
          closeCalendar();
        }
      });

      window.addEventListener('resize', function () {
        if (isCalendarOpen()) {
          positionCalendar();
        }
      });

      window.addEventListener('scroll', function () {
        if (isCalendarOpen()) {
          positionCalendar();
        }
      }, true);

      var form = null;
      var submitStateTimer = null;

      function findProductForm() {
        if (nativeDateInput && nativeDateInput.form) {
          return nativeDateInput.form;
        }

        if (cfg.formId) {
          var configuredForm = document.getElementById(cfg.formId);

          if (configuredForm) {
            return configuredForm;
          }
        }

        return root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
      }

      function connectInputsToForm() {
        form = findProductForm();

        if (!form) return;

        nativeDateInput.name = 'properties[Delivery / Collection Date]';
        isoDateInput.name = 'properties[_Delivery / Collection Date ISO]';

        if (form.id) {
          nativeDateInput.setAttribute('form', form.id);
          isoDateInput.setAttribute('form', form.id);
        }

        /*
          Keep the property inputs inside the actual product form as well as
          setting the form attribute. This preserves Horizon-style validation,
          and also supports AJAX cart scripts that serialize only descendants
          of the product form instead of using native FormData(form).
        */
        if (nativeDateInput.parentNode !== form) {
          form.appendChild(nativeDateInput);
        }

        if (isoDateInput.parentNode !== form) {
          form.appendChild(isoDateInput);
        }

        if (cfg.requireDate) {
          nativeDateInput.setAttribute('required', 'required');
          nativeDateInput.setAttribute('aria-required', 'true');
        } else {
          nativeDateInput.removeAttribute('required');
          nativeDateInput.removeAttribute('aria-required');
        }
      }

      function setNativeValidity(message) {
        if (!nativeDateInput) return;

        if (!cfg.requireDate || nativeDateInput.value) {
          nativeDateInput.setCustomValidity('');
        } else {
          nativeDateInput.setCustomValidity(message || cfg.labels.required || 'Please choose a delivery date.');
        }
      }

      function getVariantIdFromForm() {
        connectInputsToForm();

        if (!form) return '';

        var idInput = form.querySelector('[name="id"]');

        return idInput ? idInput.value : '';
      }

      function publishActivePayload() {
        connectInputsToForm();

        if (!nativeDateInput.value) {
          if (globalState.activePayload && globalState.activePayload.rootId === id) {
            globalState.activePayload = null;
          }

          return;
        }

        globalState.activePayload = {
          rootId: id,
          formId: form && form.id ? form.id : '',
          variantId: getVariantIdFromForm(),
          human: nativeDateInput.value,
          iso: isoDateInput.value || '',
          expiresAt: Date.now() + 5000
        };
      }

      function writeToForm(human, isoStr) {
        connectInputsToForm();

        nativeDateInput.value = human || '';
        isoDateInput.value = isoStr || '';
        setNativeValidity(nativeDateInput.value ? '' : cfg.labels.required);

        nativeDateInput.dispatchEvent(new Event('input', { bubbles: true }));
        nativeDateInput.dispatchEvent(new Event('change', { bubbles: true }));
        isoDateInput.dispatchEvent(new Event('input', { bubbles: true }));
        isoDateInput.dispatchEvent(new Event('change', { bubbles: true }));

        publishActivePayload();
      }

      function submitButtonSelector() {
        return [
          '[type="submit"]',
          'button[name="add"]',
          'input[name="add"]',
          '[data-add-to-cart]',
          '.product-form__submit',
          '.shopify-payment-button__button'
        ].join(',');
      }

      function getSubmitterForm(submitter) {
        if (!submitter) return null;
        if (submitter.form) return submitter.form;

        var formAttr = submitter.getAttribute && submitter.getAttribute('form');

        if (formAttr) {
          return document.getElementById(formAttr);
        }

        return submitter.closest ? submitter.closest('form') : null;
      }

      function submitterBelongsToThisForm(submitter) {
        connectInputsToForm();

        if (!form || !submitter) return false;

        var submitterForm = getSubmitterForm(submitter);

        if (submitterForm) {
          return submitterForm === form;
        }

        return form.contains(submitter);
      }

      function setSubmitState(enabled) {
        connectInputsToForm();

        if (!form || !cfg.requireDate) return;

        Array.prototype.slice.call(document.querySelectorAll(submitButtonSelector())).forEach(function (btn) {
          if (!submitterBelongsToThisForm(btn) || root.contains(btn)) {
            return;
          }

          if (enabled) {
            btn.removeAttribute('aria-disabled');
            btn.removeAttribute('data-ddp-date-locked');
          } else {
            btn.setAttribute('aria-disabled', 'true');
            btn.setAttribute('data-ddp-date-locked', 'true');
          }
        });
      }

      function showRequiredMessage(message) {
        warnEl.hidden = false;
        warnEl.textContent = message || cfg.labels.required;
        setNativeValidity(message || cfg.labels.required);
        openCalendar();

        try {
          fieldBtn.focus({ preventScroll: true });
        } catch (error) {
          fieldBtn.focus();
        }
      }

      function stopAddToCartEvent(event) {
        if (!event) return;

        event.preventDefault();
        event.stopPropagation();

        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
      }

      function blockAddToCart(event, message) {
        stopAddToCartEvent(event);
        showRequiredMessage(message);
        return false;
      }

      function validateBeforeAddToCart(event) {
        connectInputsToForm();
        compute();

        if (!cfg.requireDate) {
          return true;
        }

        if (!selected || !nativeDateInput.value) {
          writeToForm('', '');
          setSubmitState(false);
          return blockAddToCart(event, cfg.labels.required);
        }

        if (!selectable(selected)) {
          clearSelection();
          showExpiredWarning();
          refresh();
          openCalendar();
          stopAddToCartEvent(event);
          return false;
        }

        setNativeValidity('');
        publishActivePayload();
        setSubmitState(true);
        return true;
      }

      function scheduleSubmitStateRefresh() {
        if (!cfg.requireDate) return;

        window.clearTimeout(submitStateTimer);

        submitStateTimer = window.setTimeout(function () {
          connectInputsToForm();
          compute();
          setNativeValidity(nativeDateInput.value ? '' : cfg.labels.required);
          setSubmitState(Boolean(selected && selectable(selected)));
        }, 0);
      }

      connectInputsToForm();
      writeToForm('', '');

      if (cfg.requireDate) {
        setSubmitState(false);
      }

      nativeDateInput.addEventListener('invalid', function (event) {
        event.preventDefault();
        showRequiredMessage(cfg.labels.required);
      });

      document.addEventListener('click', function (event) {
        var target = event.target;

        if (!target || typeof target.closest !== 'function') return;

        var submitter = target.closest(submitButtonSelector());

        if (!submitter || root.contains(submitter) || !submitterBelongsToThisForm(submitter)) {
          return;
        }

        validateBeforeAddToCart(event);
      }, true);

      document.addEventListener('submit', function (event) {
        connectInputsToForm();

        if (!form || event.target !== form) return;

        validateBeforeAddToCart(event);
      }, true);

      if (window.MutationObserver && cfg.requireDate) {
        new MutationObserver(scheduleSubmitStateRefresh).observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }

      refresh();
      setInterval(refresh, 30000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pk-cutoff-anouncement"] && !Shopify.designMode) return;
  try {
    (function () {
    var WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    function plural(value, singular, pluralWord) {
      return value === 1 ? singular : pluralWord;
    }

    function formatCountdown(milliseconds) {
      var totalMinutes = Math.max(1, Math.ceil(milliseconds / 60000));
      var days = Math.floor(totalMinutes / 1440);
      var remainingAfterDays = totalMinutes % 1440;
      var hours = Math.floor(remainingAfterDays / 60);
      var minutes = remainingAfterDays % 60;

      if (days > 0 && hours > 0) {
        return days + ' ' + plural(days, 'day', 'days') + ' ' + hours + ' ' + plural(hours, 'hour', 'hours');
      }

      if (days > 0) {
        return days + ' ' + plural(days, 'day', 'days');
      }

      if (hours > 0 && minutes > 0) {
        return (
          hours +
          ' ' +
          plural(hours, 'hour', 'hours') +
          ' ' +
          minutes +
          ' ' +
          plural(minutes, 'minute', 'minutes')
        );
      }

      if (hours > 0) {
        return hours + ' ' + plural(hours, 'hour', 'hours');
      }

      return minutes + ' ' + plural(minutes, 'minute', 'minutes');
    }

    function getZonedParts(date, timezone) {
      var formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone || 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      var parts = formatter.formatToParts(date);
      var output = {};

      parts.forEach(function (part) {
        if (part.type !== 'literal') {
          output[part.type] = parseInt(part.value, 10);
        }
      });

      if (output.hour === 24) {
        output.hour = 0;
      }

      return output;
    }

    function zonedTimeToUtcMillis(year, month, day, hour, minute, second, timezone) {
      var targetAsUtc = Date.UTC(year, month - 1, day, hour, minute, second || 0);
      var guess = targetAsUtc;

      for (var i = 0; i < 4; i++) {
        var parts = getZonedParts(new Date(guess), timezone);

        var guessAsUtc = Date.UTC(
          parts.year,
          parts.month - 1,
          parts.day,
          parts.hour,
          parts.minute,
          parts.second || 0
        );

        guess += targetAsUtc - guessAsUtc;
      }

      return guess;
    }

    function addDaysToZonedParts(parts, days) {
      var date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
      date.setUTCDate(date.getUTCDate() + days);

      return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        day: date.getUTCDate()
      };
    }

    function getWeekdayFromZonedDateParts(parts) {
      var date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
      return date.getUTCDay();
    }

    function isDeliveryDay(parts) {
      var weekday = getWeekdayFromZonedDateParts(parts);

      /*
        Delivery days:
        Tuesday = 2
        Wednesday = 3
        Thursday = 4
        Friday = 5
        Saturday = 6

        No delivery:
        Sunday = 0
        Monday = 1
      */
      return weekday >= 2 && weekday <= 6;
    }

    function parseCutoffTime(value) {
      var raw = String(value || '12:00').trim();
      var match = raw.match(/^(\d{1,2})(?::(\d{1,2}))?$/);

      if (!match) {
        return {
          hour: 12,
          minute: 0
        };
      }

      var hour = parseInt(match[1], 10);
      var minute = parseInt(match[2] || '0', 10);

      if (isNaN(hour) || hour < 0 || hour > 23) {
        hour = 12;
      }

      if (isNaN(minute) || minute < 0 || minute > 59) {
        minute = 0;
      }

      return {
        hour: hour,
        minute: minute
      };
    }

    function getDeliveryDayLabel(daysFromToday, targetDateParts) {
      if (daysFromToday === 0) {
        return 'today';
      }

      if (daysFromToday === 1) {
        return 'tomorrow';
      }

      return WEEKDAY_NAMES[getWeekdayFromZonedDateParts(targetDateParts)];
    }

    function getNextZonedMidnightUtc(parts, timezone) {
      var tomorrow = addDaysToZonedParts(parts, 1);

      return zonedTimeToUtcMillis(
        tomorrow.year,
        tomorrow.month,
        tomorrow.day,
        0,
        0,
        0,
        timezone
      );
    }

    function getDeliveryState(now, shopNow, cutoff, timezone) {
      var todayCutoffUtc = zonedTimeToUtcMillis(
        shopNow.year,
        shopNow.month,
        shopNow.day,
        cutoff.hour,
        cutoff.minute,
        0,
        timezone
      );

      var todayIsDeliveryDay = isDeliveryDay(shopNow);
      var beforeTodayCutoff = todayCutoffUtc - now.getTime() > 0;

      if (todayIsDeliveryDay && beforeTodayCutoff) {
        return {
          messageKey: 'same-day',
          targetUtc: todayCutoffUtc,
          deliveryDayLabel: 'today'
        };
      }

      for (var daysFromToday = 1; daysFromToday <= 8; daysFromToday++) {
        var targetDateParts = addDaysToZonedParts(shopNow, daysFromToday);

        if (!isDeliveryDay(targetDateParts)) {
          continue;
        }

        var targetCutoffUtc = zonedTimeToUtcMillis(
          targetDateParts.year,
          targetDateParts.month,
          targetDateParts.day,
          cutoff.hour,
          cutoff.minute,
          0,
          timezone
        );

        var targetWeekday = getWeekdayFromZonedDateParts(targetDateParts);
        var messageKey = 'next-delivery-day';
        var countdownTargetUtc = targetCutoffUtc;

        if (daysFromToday === 1) {
          messageKey = 'next-day';

          /*
            If today is not a delivery day but tomorrow is, for example Monday -> Tuesday,
            the customer only needs to order before midnight today for delivery tomorrow.
            Counting down to tomorrow's cut-off would show "1 day x hours", which reads oddly.
          */
          if (!todayIsDeliveryDay) {
            countdownTargetUtc = getNextZonedMidnightUtc(shopNow, timezone);
          }
        } else if (targetWeekday === 2) {
          messageKey = 'tuesday';
        }

        return {
          messageKey: messageKey,
          targetUtc: countdownTargetUtc,
          deliveryDayLabel: getDeliveryDayLabel(daysFromToday, targetDateParts)
        };
      }

      var fallbackTomorrow = addDaysToZonedParts(shopNow, 1);

      return {
        messageKey: 'next-delivery-day',
        targetUtc: zonedTimeToUtcMillis(
          fallbackTomorrow.year,
          fallbackTomorrow.month,
          fallbackTomorrow.day,
          cutoff.hour,
          cutoff.minute,
          0,
          timezone
        ),
        deliveryDayLabel: 'tomorrow'
      };
    }

    function setTextForAll(elements, text) {
      elements.forEach(function (element) {
        element.textContent = text;
      });
    }

    function updateCountdown(announcement) {
      var timezone = announcement.getAttribute('data-cutoff-timezone') || 'Europe/London';
      var cutoff = parseCutoffTime(announcement.getAttribute('data-cutoff-time'));
      var now = new Date();
      var shopNow = getZonedParts(now, timezone);
      var deliveryState = getDeliveryState(now, shopNow, cutoff, timezone);
      var remainingMilliseconds = deliveryState.targetUtc - now.getTime();

      var messageEls = announcement.querySelectorAll('[data-cutoff-message]');
      var countdownEls = announcement.querySelectorAll('[data-cutoff-countdown]');
      var deliveryDayEls = announcement.querySelectorAll('[data-delivery-day]');

      messageEls.forEach(function (messageEl) {
        messageEl.hidden = messageEl.getAttribute('data-cutoff-message') !== deliveryState.messageKey;
      });

      setTextForAll(countdownEls, formatCountdown(remainingMilliseconds));
      setTextForAll(deliveryDayEls, deliveryState.deliveryDayLabel);
    }

    function tickPkCutoffCountdowns() {
      var announcements = document.querySelectorAll('[data-cutoff-announcement]');

      announcements.forEach(function (announcement) {
        updateCountdown(announcement);
      });
    }

    function initPkCutoffCountdowns() {
      if (window.__announcementCutoffCountdownInterval) {
        window.clearInterval(window.__announcementCutoffCountdownInterval);
        window.__announcementCutoffCountdownInterval = null;
      }

      if (window.__pkCutoffAnnouncementInterval) {
        window.clearInterval(window.__pkCutoffAnnouncementInterval);
        window.__pkCutoffAnnouncementInterval = null;
      }

      tickPkCutoffCountdowns();

      window.__pkCutoffAnnouncementInterval = window.setInterval(tickPkCutoffCountdowns, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPkCutoffCountdowns);
    } else {
      initPkCutoffCountdowns();
    }

    document.addEventListener('shopify:section:load', initPkCutoffCountdowns);
    document.addEventListener('shopify:block:select', initPkCutoffCountdowns);
  })();
  } catch(e) { console.error(e); }
})();

})();
